import Vue from 'vue'
import axios from 'axios'
import Buefy from 'buefy'
import { mask } from 'vue-the-mask'
import VueCurrencyFilter from 'vue-currency-filter'

import App from './App'
import router from './router'
import store from './store'
import { api } from './api'

Vue.use(Buefy, { defaultIconPack: 'fas' })

Vue.use(VueCurrencyFilter, {
  symbol: 'R$',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true
})

Vue.directive('mask', mask)

Vue.prototype.$api = api
Vue.prototype.$http = axios

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
